
import { defineComponent } from "vue";

import TransportCatalogue from "@/components/catalogues/TransportCatalogue/TransportCatalogue.vue";

export default defineComponent({
  components: { TransportCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
